import { Link, LinkProps } from 'react-router-dom'

import { T } from '@tribeplatform/react-components/i18n'
import { cn } from '@tribeplatform/react-components/utils/cn'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

export function AddSpace({ className, ...props }: LinkProps) {
  return (
    <NavVertical.Item
      as={Link}
      leadingIcon={<SvgIcon name="file-plus-02" size="lg" />}
      className={cn('mb-1', className)}
      {...props}
    >
      <div className="flex-1 truncate">
        <T defaultMessage="Add {SPACE}" id="Generics.AddSpace" />

        <Tooltip>
          <Tooltip.Trigger className="inline-block">
            <SvgIcon
              inline
              className="ms-1 shrink-0"
              name="alert-circle"
              size="sm"
            />
          </Tooltip.Trigger>
          <Tooltip.Panel>
            <T
              defaultMessage="Create a versatile area for discussions, content, pages, or groups."
              id="Admin.CollectionsAndSpaces.CreateSpaceTooltip"
            />
          </Tooltip.Panel>
        </Tooltip>
      </div>
    </NavVertical.Item>
  )
}
